import { getImg } from "../../Api/getImg";

export default function NewsCard({ title, image, summary, date, index }) {

    return (
        <div
            className=" rounded-2xl   overflow-hidden  hover:scale-105 cursor-pointer transition-all duration-300 animate-fade-in"
            style={{ animationDelay: `${index * 0.1}s` }}
        >
            <div className="relative rounded-xl">
                <img
                    src={getImg(image)}
                    alt={title}
                    className="w-full h-62 sm:h-72  rounded-xl object-cover"
                    loading="lazy"
                    onError={(e) => (e.target.src = 'https://via.placeholder.com/400x300?text=Fallback+Image')}
                />
            </div>
            <div className="p-4 sm:p-5 flex flex-col justify-between items-center h-[200px] sm:h-[220px]">
                    {/* <p className="text-xs sm:text-sm text-gray-400">{date}</p> */}
                <div>
                    <h3 className="text-base text-center sm:text-2xl font-semibold text-primary mb-2 line-clamp-2">
                        {title}
                    </h3>
                    <p className="text-gray-600  text-center  text-sm sm:text-base line-clamp-3">
                        {summary}
                    </p>
                </div>
                <div className="flex  items-center mt-3">
                    {/* <button
                        className="text-xs sm:text-base rounded-lg bg-primary text-white px-2 md:w-44 py-2 hover:text-secondary font-medium hover:scale-105 transition-all duration-200"
                        aria-label={`Read more about ${title}`}
                    >
                        Read More
                    </button> */}
                </div>
            </div>

            <style jsx>{`
                @keyframes fade-in {
                    from {
                        opacity: 0;
                        transform: translateY(10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .animate-fade-in {
                    animation: fade-in 0.5s ease-in-out;
                }
            `}</style>
        </div>
    );
}
